/**
 * Экспорт статистики аккаунтов в Google Таблицы (TSV) и PDF
 */

import { exportElementToPdf } from './export-pdf';

import type { AccountStatsRow } from '../types/account-stats';

const HEADERS = ['Аккаунт', 'Теги', 'Подписчики', 'Показы', 'Охваты', 'Взаимодействия', 'ER (%)'];

function formatNum(value: number | null): string {
  if (value === null) return '—';
  return value.toLocaleString('ru-RU');
}

function formatEr(value: number | null): string {
  if (value === null) return '—';
  return value.toFixed(2);
}

function buildTsv(rows: AccountStatsRow[]): string {
  const dataRows = rows.map(row => [
    `@${row.username}`,
    row.tags.join(', '),
    formatNum(row.followers),
    formatNum(row.impressions),
    formatNum(row.reach),
    formatNum(row.interactions),
    formatEr(row.er),
  ]);
  return [HEADERS, ...dataRows].map(row => row.join('\t')).join('\n');
}

export async function copyAccountStatsTsv(rows: AccountStatsRow[]): Promise<void> {
  const tsv = buildTsv(rows);
  await navigator.clipboard.writeText(tsv);
}

export function exportAccountStatsPdf(tableElement: HTMLElement): Promise<void> {
  return exportElementToPdf(tableElement, 'accounts-stats');
}
